import { Injectable, inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class AuthGuard {
  static readonly canActivate: CanActivateFn = (route, state) => {
    const router = inject(Router);
    const isLoggedIn = !!localStorage.getItem('auth_token');

    if (isLoggedIn) {
      return true;
    }

    return router.parseUrl('/auth/login');
  };
}
